'use client';
var classes = {"root":"m_410352e9","inner":"m_dee7bd2f","col":"m_96bdd299"};

export { classes as default };
//# sourceMappingURL=Grid.module.css.mjs.map
